<template>
  <div>
    <div class="vld-parent">
      <loading style="margin-bottom: 800px;" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"
        loader="dots" color="#0096FF" >
      </loading>
    </div>

    <div class="row mb-4">

      <div class="col-md-12 float-right">

        <button class="btn pull-right" style="margin-bottom:20px ;font-weight:bold;background-color:#4cbb17; color:white"
         @click="downloadFilteredQrCodes">Download QrCodes</button>
        <button class="btn pull-right" style="margin-bottom:20px ;font-weight:bold;background-color:#4cbb17; color:white"
         @click="importUsersBtnClicked">Importar Usuários</button>
        <a :href="$store.getters.url + 'layouts/importUsersLayout'" target="_blank" class="btn pull-right"><i
            class='fa fa-download' style="margin-right:5px"></i>Modelo</a>

        <input v-show="false" type="file" id="importUsersInput" @change="importUsers()" />
        <label class="switch pull-right" style="margin-left:0.5%;margin-top:0.5%;">
          <input type="checkbox" v-model="usersDeleted" @change="toggleDeleted">
          <span class="slider round"></span>
        </label>
        <span class="pull-right" style="margin-top: 0.5%;">Mostrar Usuários Desligados</span>
      </div>
    </div>
    <base-crud crudName="Usuários" newText="Novo Usuário" :table="userTable" :columns="columns" :options="options"
      :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="false" :enableView="true" :extra="extra"
      @downloadQRCode="downloadQRCode" @sendToAPI="sendToAPI" @exportDataUser="exportDataUser"
      ref="userTable"></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';


export default {
  data: function () {
    return {
      isLoading: false,
      fullPage: true,
      usersDeleted: false,
      userTable: "userTable",
      users: [],
      pages: [],
      url: "",
      columns: ["id", "photo", "name", "registry", "branch_id", "team_id", "email", "role_id", "qrcodevue", 'term_accepted', 'term_accepted_at', 'deleted_at', 'sign_url', "actions"],
      tableData: ["id", "photo", "name", "registry", "branch_id", "team_id", "email", "role_id", "qrcodevue", 'term_accepted', 'term_accepted_at', 'deleted_at', 'sign_url'],
      options: {
        filterable: ["id", "name", "registry", "branch_id", "team_id", "email"],
        filterByColumn: true,
        sortable: ["id", "name", "email"],
        templates: {
          team_id: (h, row, index) => {
            return row.team ? row.team.name : '';
          },
          branch_id: (h, row, index) => {
            return row.branch ? row.branch.name : '';
          },
          role_id: (h, row, index) => {
            return row.role ? row.role.name : '';
          },
          term_accepted: (h, row, index) => {
            return row.term_accepted == 1 ? 'Aceito' : 'Ainda não aceito';
          },
          deleted_at: (h, row, index) => {
            return row.deleted_at == null ? 'Ativo' : 'Desativado';
          },
          term_accepted_at: (h, row, index) => {
            return row.term_accepted_at ?
              row.term_accepted_at.substr(8, 2) + '/' +
              row.term_accepted_at.substr(5, 2) + '/' +
              row.term_accepted_at.substr(0, 4)
              : '';
          }
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          name: "Nome",
          registry: "Matricula",
          qrcodevue: "QR Code",
          team_id: "Área",
          branch_id: "Unidade",
          role_id: "Cargo",
          email: "E-mail",
          deleted_at: "Ativo",
          term_accepted: 'Termo Aceito',
          term_accepted_at: 'Termo aceito em',
          sign_url: 'Assinatura de termo',
          actions: "Ações"
        },
        requestFunction: function (data) {
          let requestData = {};

          // Obtem a query inicial
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ['team', 'role', 'branch'];


          requestData.params.filter = {};


          if (query.trim() === "") {
            query = "";
          }


          if (query.trim() === "") {
            requestData.params.per_page = this.options.perPage;
          } else {
            console.log('entrou');
            requestData.params.per_page = 1000;
            this.perPage = false;
            this.perPageValues = false;
          }

          // Retorna a requisição com a query completa
          return this.$http
            .get(this.url + '?' + query, requestData)
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        }

      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-info blue fa fa-download",
          title: "Baixar QRCode",
          name: "downloadQRCode",
          icon: ""
        },
        {
          id: 2,
          label: "",
          class: "btn btn-danger fa fa-trash",
          title: "Excluir",
          name: "sendToAPI",
          icon: "fa fa-trash",
        },
        {
          id: 3,
          label: "",
          class: "btn btn-warning2 armor fa fa-user",
          title: "Dados Usuario",
          name: "exportDataUser",
          icon: "fa fa-trash",
        },
      ],
      endPoint: "users/"
    };
  },
  methods: {
    toggleDeleted() {

      this.$refs.userTable.$refs.table.refresh();
    },
    sendToAPI(props) {
      let api = this.$store.state.api + "users/participation/" + props.row.id;
      let self = this;

      let id = props.row.id;

      self.$http
        .get(api)
        .then((response) => {
          const data = response.data;
          console.log(data);

          if (data.status === 'success') {

            this.alredyParticipated(props, data.message);
          } else {

            this.alredyParticipated(props, data.message);
          }
        })
        .catch((error) => {
          self.errors = error.response.data;
          console.error(self.errors);

          self.$message(
            null,
            'Ocorreu um erro ao carregar as informações',
            'error'
          );
        });
    },
    exportDataUser(props) {
      let api = this.$store.state.api + "users/exportdatauser/" + props.row.id;
      let self = this;

      console.log(props.row.id);

      self.$http
        .get(api, { responseType: 'blob' })
        .then((response) => {
          // Crie um link temporário para baixar o PDF
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'user_report.pdf');
          document.body.appendChild(link);
          link.click();

          // Remover o link após o download
          document.body.removeChild(link);
        })
        .catch((error) => {
          self.errors = error.response.data;
          console.error(self.errors);

          self.$message(
            null,
            'Ocorreu um erro ao carregar as informações',
            'error'
          );
        });
    },

    alredyParticipated(props, data) {

      swal({
        title: 'Confirmação',
        text: data,
        icon: 'warning',
        buttons: ['Cancelar', 'Sim'],
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {

          let api = this.$store.state.api + "users/delete/" + props.row.id;
          let self = this;

          self.$http
            .get(api)
            .then((response) => {
              const data = response.data;
              swal('Usuário Deletado', 'O usuário foi deletado com sucesso.', 'success');

            })
            .catch((error) => {

              self.$message(
                null,
                'Ocorreu um erro ao carregar as informações',
                'error'
              );
            });
        } else {
          swal('Cancelado', '', 'warning');
        }
      });
    },

    importUsersBtnClicked() {
      document.getElementById('importUsersInput').value = ''
      $("#importUsersInput").click();
    },
    importUsers() {
      this.isLoading = true;
      const self = this;
      const api = self.$store.state.api + "users/importUsers";

      const fd = new FormData();
      const file = document.getElementById("importUsersInput").files[0];

      if (file) {
        fd.append("file", file);
      } else return;

      self.$http
        .post(api, fd)
        .then(response => {
          this.$refs.userTable.$refs.table.refresh();
          this.isLoading = false;
          self.$message(
            "Sucesso",
            "Importação realizada com sucesso",
            "success"
          );
        })
        .catch(error => {
          document.getElementById("importUsersInput").value = "";
          this.isLoading = false;
          self.$message(
            "Erro",
            "Ocorreu um erro. Por favor, verifique se o tipo de arquivo é XLSX e se todos os dados estão preenchidos de forma correta",
            "error"
          );
        });
    },
    downloadQRCode(props) {
      let self = this;

      window.open(
        self.$store.getters.url +
        "users/downloadqrcode/" +
        props.row.id,
        "_blank"
      );
    },
    downloadFilteredQrCodes(props) {
      let self = this;
      console.log('alo')

      window.open(
        self.$store.getters.url +
        "users/downloadFilteredQrCodes",
        "_blank"
      );
    },
    query: function (query) {
      let columns = {
        id: 'id',
        name: 'name',
        email: 'email',
        team_id: 'team[name]',
        branch_id: 'branch[name]',
        registry: 'registry',
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      filters += "usersDeleted=" + this.usersDeleted;

      return filters;
    }
  },
  components: {
    BaseCrud,
    QrcodeVue,
    Loading
  }
};
</script>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 10px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #4cbb17;
}

input:checked+.slider:before {
  transform: translateX(14px);
}

.VuePagination {
  text-align: center;
}

.btn.btn-warning2 {
  background-color: rgb(7, 101, 124) !important;
  color: white !important;
}
.btn.disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Crud.vue